import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles/globals.css';
import './styles/variables.css';
import './styles/animations.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);